import { LocalStorageFeatureFlags } from '@backstage/core-app-api';

import { useFlag } from '@spotify-confidence/react';

export class ConfidenceFeatureFlags extends LocalStorageFeatureFlags {
  isActive(name: string): boolean {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isFlagEnabled = useFlag(`${name}.enabled`, false);
    return super.isActive(name) || isFlagEnabled;
  }
}
